import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import { AudioProvider } from "./contexts/AudioContext";
import Index from "./pages/Index";

const WhereRiskForms = lazy(() => import("./pages/WhereRiskForms"));
const Timing = lazy(() => import("./pages/Timing"));
const About = lazy(() => import("./pages/About"));
const WhoThisIsFor = lazy(() => import("./pages/WhoThisIsFor"));
const BookACall = lazy(() => import("./pages/BookACall"));
const BookingConfirmation = lazy(() => import("./pages/BookingConfirmation"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AudioProvider>
        <Suspense fallback={null}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Index />} />
              <Route path="/where-risk-forms" element={<WhereRiskForms />} />
              <Route path="/timing" element={<Timing />} />
              <Route path="/about" element={<About />} />
              <Route path="/who-this-is-for" element={<WhoThisIsFor />} />
              <Route path="/book-a-call" element={<BookACall />} />
              <Route path="/booking-confirmed" element={<BookingConfirmation />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        </AudioProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
